// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,ts_nocheck=true"
// @generated from file pull_requests/v1/timeline.proto (package github.pull_requests.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file pull_requests/v1/timeline.proto.
 */
export const file_pull_requests_v1_timeline: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_wrappers]);

/**
 * Response payload for
 * GET /:owner/:repo/pull/:number/page_data/timeline
 *
 * Defined by PullRequests::PageData::SharedController#timeline.
 *
 * The legacy endpoint renders a top-level JSON array of timeline items.
 * Proto3-JSON always serializes a message to an object, so the array is
 * wrapped in a repeated `items` field; the client reads `response.items`.
 *
 * @generated from message github.pull_requests.v1.TimelineResponse
 */
export type TimelineResponse = Message<"github.pull_requests.v1.TimelineResponse"> & {
  /**
   * @generated from field: repeated github.pull_requests.v1.TimelineItem items = 1;
   */
  items: TimelineItem[];
};

/**
 * Describes the message github.pull_requests.v1.TimelineResponse.
 * Use `create(TimelineResponseSchema)` to create a new message.
 */
export const TimelineResponseSchema: GenMessage<TimelineResponse> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_timeline, 0);

/**
 * A single timeline entry. `additional_info` is a `oneof` keyed on the item's
 * `type` (see AdditionalInfo); the populated arm matches the item type, and
 * proto3 omits the message entirely when there is no metadata.
 *
 * @generated from message github.pull_requests.v1.TimelineItem
 */
export type TimelineItem = Message<"github.pull_requests.v1.TimelineItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * The kind of timeline entry. Serializes as the UPPER_SNAKE_CASE enum value
   * name (e.g. TIMELINE_ITEM_TYPE_ISSUE_COMMENT); the client maps it back to
   * its own representation. Unknown/future types serialize as
   * TIMELINE_ITEM_TYPE_UNSPECIFIED.
   *
   * @generated from field: github.pull_requests.v1.TimelineItemType type = 2;
   */
  type: TimelineItemType;

  /**
   * ISO8601 timestamp. Wrapper type because the serializer can emit null.
   *
   * @generated from field: google.protobuf.StringValue timestamp = 3;
   */
  timestamp?: string;

  /**
   * Null/absent for some item types (e.g. PullRequestRevisionMarker). A
   * message field cannot carry an explicit JSON null, so absent is read as
   * null by the client.
   *
   * @generated from field: github.pull_requests.v1.TimelineUser user = 4;
   */
  user?: TimelineUser;

  /**
   * Per-type metadata. Absent (read as null by the client) when the item has
   * no additional info, e.g. PullRequestReviewThread, IssueEdit.
   *
   * @generated from field: github.pull_requests.v1.AdditionalInfo additional_info = 5;
   */
  additionalInfo?: AdditionalInfo;
};

/**
 * Describes the message github.pull_requests.v1.TimelineItem.
 * Use `create(TimelineItemSchema)` to create a new message.
 */
export const TimelineItemSchema: GenMessage<TimelineItem> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_timeline, 1);

/**
 * @generated from message github.pull_requests.v1.TimelineUser
 */
export type TimelineUser = Message<"github.pull_requests.v1.TimelineUser"> & {
  /**
   * User id. int64 (serialized as a JSON string) since user ids can exceed
   * the int32 range.
   *
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string display_login = 2;
   */
  displayLogin: string;

  /**
   * @generated from field: string avatar_url = 3;
   */
  avatarUrl: string;

  /**
   * Stable GitHub App slug for bot actors. The display login may be replaced
   * with an agentic app's friendly display name.
   *
   * @generated from field: string slug = 4;
   */
  slug: string;

  /**
   * @generated from field: github.pull_requests.v1.UserType user_type = 5;
   */
  userType: UserType;
};

/**
 * Describes the message github.pull_requests.v1.TimelineUser.
 * Use `create(TimelineUserSchema)` to create a new message.
 */
export const TimelineUserSchema: GenMessage<TimelineUser> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_timeline, 2);

/**
 * @generated from message github.pull_requests.v1.Label
 */
export type Label = Message<"github.pull_requests.v1.Label"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string color = 2;
   */
  color: string;
};

/**
 * Describes the message github.pull_requests.v1.Label.
 * Use `create(LabelSchema)` to create a new message.
 */
export const LabelSchema: GenMessage<Label> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_timeline, 3);

/**
 * Per-type metadata, modeled as a `oneof` keyed on the item's `type`. Each
 * arm is its own message so the JSON nests under the member name, e.g.
 * `{ "additionalInfo": { "issueComment": { "commentId": "1" } } }`. The client
 * narrows on whichever member is present. Wrapper types are used within each
 * arm where a value can be absent vs. present, or where a zero/false value is
 * meaningful and must not be omitted as a proto3 default.
 *
 * @generated from message github.pull_requests.v1.AdditionalInfo
 */
export type AdditionalInfo = Message<"github.pull_requests.v1.AdditionalInfo"> & {
  /**
   * @generated from oneof github.pull_requests.v1.AdditionalInfo.info
   */
  info: {
    /**
     * @generated from field: github.pull_requests.v1.IssueCommentInfo issue_comment = 1;
     */
    value: IssueCommentInfo;
    case: "issueComment";
  } | {
    /**
     * @generated from field: github.pull_requests.v1.IssueEventInfo issue_event = 2;
     */
    value: IssueEventInfo;
    case: "issueEvent";
  } | {
    /**
     * @generated from field: github.pull_requests.v1.PullRequestReviewInfo pull_request_review = 3;
     */
    value: PullRequestReviewInfo;
    case: "pullRequestReview";
  } | {
    /**
     * @generated from field: github.pull_requests.v1.PullRequestCommitInfo pull_request_commit = 4;
     */
    value: PullRequestCommitInfo;
    case: "pullRequestCommit";
  } | {
    /**
     * @generated from field: github.pull_requests.v1.PullRequestRevisionMarkerInfo pull_request_revision_marker = 5;
     */
    value: PullRequestRevisionMarkerInfo;
    case: "pullRequestRevisionMarker";
  } | {
    /**
     * @generated from field: github.pull_requests.v1.CrossReferenceInfo cross_reference = 6;
     */
    value: CrossReferenceInfo;
    case: "crossReference";
  } | {
    /**
     * @generated from field: github.pull_requests.v1.CopilotWorkStartedEventInfo copilot_work_started_event = 7;
     */
    value: CopilotWorkStartedEventInfo;
    case: "copilotWorkStartedEvent";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message github.pull_requests.v1.AdditionalInfo.
 * Use `create(AdditionalInfoSchema)` to create a new message.
 */
export const AdditionalInfoSchema: GenMessage<AdditionalInfo> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_timeline, 4);

/**
 * @generated from message github.pull_requests.v1.IssueCommentInfo
 */
export type IssueCommentInfo = Message<"github.pull_requests.v1.IssueCommentInfo"> & {
  /**
   * @generated from field: int64 comment_id = 1;
   */
  commentId: bigint;
};

/**
 * Describes the message github.pull_requests.v1.IssueCommentInfo.
 * Use `create(IssueCommentInfoSchema)` to create a new message.
 */
export const IssueCommentInfoSchema: GenMessage<IssueCommentInfo> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_timeline, 5);

/**
 * @generated from message github.pull_requests.v1.IssueEventInfo
 */
export type IssueEventInfo = Message<"github.pull_requests.v1.IssueEventInfo"> & {
  /**
   * @generated from field: string event_type = 1;
   */
  eventType: string;

  /**
   * @generated from field: github.pull_requests.v1.Label label = 2;
   */
  label?: Label;

  /**
   * @generated from field: google.protobuf.StringValue reviewer_login = 3;
   */
  reviewerLogin?: string;

  /**
   * @generated from field: google.protobuf.StringValue reviewer_team_slug = 4;
   */
  reviewerTeamSlug?: string;

  /**
   * @generated from field: google.protobuf.StringValue assignee_login = 5;
   */
  assigneeLogin?: string;

  /**
   * @generated from field: google.protobuf.StringValue previous_title = 6;
   */
  previousTitle?: string;

  /**
   * @generated from field: google.protobuf.StringValue new_title = 7;
   */
  newTitle?: string;

  /**
   * @generated from field: google.protobuf.StringValue before_commit_oid = 8;
   */
  beforeCommitOid?: string;

  /**
   * @generated from field: google.protobuf.StringValue after_commit_oid = 9;
   */
  afterCommitOid?: string;

  /**
   * @generated from field: google.protobuf.StringValue ref = 10;
   */
  ref?: string;

  /**
   * @generated from field: google.protobuf.StringValue dismissal_message = 11;
   */
  dismissalMessage?: string;

  /**
   * @generated from field: google.protobuf.StringValue commit_oid = 12;
   */
  commitOid?: string;

  /**
   * @generated from field: google.protobuf.StringValue state_reason = 13;
   */
  stateReason?: string;

  /**
   * @generated from field: google.protobuf.StringValue lock_reason = 14;
   */
  lockReason?: string;

  /**
   * @generated from field: google.protobuf.StringValue review_effort_level = 15;
   */
  reviewEffortLevel?: string;

  /**
   * @generated from field: google.protobuf.StringValue session_url = 16;
   */
  sessionUrl?: string;

  /**
   * @generated from field: google.protobuf.StringValue commit_abbreviated_oid = 17;
   */
  commitAbbreviatedOid?: string;

  /**
   * @generated from field: google.protobuf.StringValue commit_short_message_text = 18;
   */
  commitShortMessageText?: string;

  /**
   * @generated from field: google.protobuf.StringValue commit_url = 19;
   */
  commitUrl?: string;

  /**
   * @generated from field: google.protobuf.StringValue commit_repository_name_with_owner = 20;
   */
  commitRepositoryNameWithOwner?: string;

  /**
   * @generated from field: google.protobuf.Int64Value stack_number = 21;
   */
  stackNumber?: bigint;

  /**
   * @generated from field: google.protobuf.StringValue removal_reason = 22;
   */
  removalReason?: string;

  /**
   * @generated from field: google.protobuf.StringValue merge_queue_url = 23;
   */
  mergeQueueUrl?: string;

  /**
   * Optional summary supplied for a Copilot session start event.
   *
   * @generated from field: google.protobuf.StringValue copilot_work_summary = 24;
   */
  copilotWorkSummary?: string;

  /**
   * @generated from field: google.protobuf.StringValue checks_commit_oid = 25;
   */
  checksCommitOid?: string;
};

/**
 * Describes the message github.pull_requests.v1.IssueEventInfo.
 * Use `create(IssueEventInfoSchema)` to create a new message.
 */
export const IssueEventInfoSchema: GenMessage<IssueEventInfo> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_timeline, 6);

/**
 * @generated from message github.pull_requests.v1.PullRequestReviewInfo
 */
export type PullRequestReviewInfo = Message<"github.pull_requests.v1.PullRequestReviewInfo"> & {
  /**
   * @generated from field: string state = 1;
   */
  state: string;

  /**
   * @generated from field: int64 review_id = 2;
   */
  reviewId: bigint;

  /**
   * @generated from field: google.protobuf.Int32Value comment_count = 3;
   */
  commentCount?: number;

  /**
   * @generated from field: google.protobuf.BoolValue is_author = 4;
   */
  isAuthor?: boolean;

  /**
   * @generated from field: google.protobuf.BoolValue qualified_reviewer = 5;
   */
  qualifiedReviewer?: boolean;

  /**
   * @generated from field: string reviewer_type = 6;
   */
  reviewerType: string;

  /**
   * @generated from field: google.protobuf.StringValue dismissed_state = 7;
   */
  dismissedState?: string;
};

/**
 * Describes the message github.pull_requests.v1.PullRequestReviewInfo.
 * Use `create(PullRequestReviewInfoSchema)` to create a new message.
 */
export const PullRequestReviewInfoSchema: GenMessage<PullRequestReviewInfo> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_timeline, 7);

/**
 * @generated from message github.pull_requests.v1.PullRequestCommitInfo
 */
export type PullRequestCommitInfo = Message<"github.pull_requests.v1.PullRequestCommitInfo"> & {
  /**
   * @generated from field: string sha = 1;
   */
  sha: string;

  /**
   * @generated from field: google.protobuf.StringValue base_sha = 2;
   */
  baseSha?: string;

  /**
   * @generated from field: google.protobuf.StringValue short_message_text = 3;
   */
  shortMessageText?: string;
};

/**
 * Describes the message github.pull_requests.v1.PullRequestCommitInfo.
 * Use `create(PullRequestCommitInfoSchema)` to create a new message.
 */
export const PullRequestCommitInfoSchema: GenMessage<PullRequestCommitInfo> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_timeline, 8);

/**
 * Where a cross-reference came from: the issue or pull request that mentioned
 * this pull request.
 *
 * @generated from message github.pull_requests.v1.CrossReferenceInfo
 */
export type CrossReferenceInfo = Message<"github.pull_requests.v1.CrossReferenceInfo"> & {
  /**
   * Cross-references are stored with source_type "Issue", but an issue backed
   * by a pull request is surfaced as "PullRequest"
   *
   * @generated from field: google.protobuf.StringValue source_type = 1;
   */
  sourceType?: string;

  /**
   * @generated from field: google.protobuf.Int32Value source_number = 2;
   */
  sourceNumber?: number;

  /**
   * @generated from field: google.protobuf.StringValue source_title = 3;
   */
  sourceTitle?: string;

  /**
   * @generated from field: google.protobuf.StringValue source_url = 4;
   */
  sourceUrl?: string;

  /**
   * @generated from field: google.protobuf.StringValue source_repository_name_with_owner = 5;
   */
  sourceRepositoryNameWithOwner?: string;

  /**
   * @generated from field: google.protobuf.StringValue source_state = 6;
   */
  sourceState?: string;

  /**
   * @generated from field: google.protobuf.StringValue source_state_reason = 7;
   */
  sourceStateReason?: string;

  /**
   * @generated from field: google.protobuf.BoolValue source_is_draft = 8;
   */
  sourceIsDraft?: boolean;

  /**
   * @generated from field: google.protobuf.BoolValue source_is_in_merge_queue = 9;
   */
  sourceIsInMergeQueue?: boolean;
};

/**
 * Describes the message github.pull_requests.v1.CrossReferenceInfo.
 * Use `create(CrossReferenceInfoSchema)` to create a new message.
 */
export const CrossReferenceInfoSchema: GenMessage<CrossReferenceInfo> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_timeline, 9);

/**
 * @generated from message github.pull_requests.v1.PullRequestRevisionMarkerInfo
 */
export type PullRequestRevisionMarkerInfo = Message<"github.pull_requests.v1.PullRequestRevisionMarkerInfo"> & {
  /**
   * @generated from field: google.protobuf.StringValue last_seen_commit_oid = 1;
   */
  lastSeenCommitOid?: string;
};

/**
 * Describes the message github.pull_requests.v1.PullRequestRevisionMarkerInfo.
 * Use `create(PullRequestRevisionMarkerInfoSchema)` to create a new message.
 */
export const PullRequestRevisionMarkerInfoSchema: GenMessage<PullRequestRevisionMarkerInfo> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_timeline, 10);

/**
 * @generated from message github.pull_requests.v1.CopilotWorkStartedEventInfo
 */
export type CopilotWorkStartedEventInfo = Message<"github.pull_requests.v1.CopilotWorkStartedEventInfo"> & {
  /**
   * @generated from field: google.protobuf.StringValue session_url = 1;
   */
  sessionUrl?: string;

  /**
   * @generated from field: github.pull_requests.v1.TimelineUser on_behalf_of = 2;
   */
  onBehalfOf?: TimelineUser;

  /**
   * @generated from field: google.protobuf.StringValue summary = 3;
   */
  summary?: string;
};

/**
 * Describes the message github.pull_requests.v1.CopilotWorkStartedEventInfo.
 * Use `create(CopilotWorkStartedEventInfoSchema)` to create a new message.
 */
export const CopilotWorkStartedEventInfoSchema: GenMessage<CopilotWorkStartedEventInfo> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_timeline, 11);

/**
 * Discriminant for a TimelineItem. The arm of AdditionalInfo populated for an
 * item corresponds to its type.
 *
 * @generated from enum github.pull_requests.v1.TimelineItemType
 */
export enum TimelineItemType {
  /**
   * @generated from enum value: TIMELINE_ITEM_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TIMELINE_ITEM_TYPE_ISSUE_COMMENT = 1;
   */
  ISSUE_COMMENT = 1,

  /**
   * @generated from enum value: TIMELINE_ITEM_TYPE_ISSUE_EVENT = 2;
   */
  ISSUE_EVENT = 2,

  /**
   * @generated from enum value: TIMELINE_ITEM_TYPE_PULL_REQUEST_REVIEW = 3;
   */
  PULL_REQUEST_REVIEW = 3,

  /**
   * @generated from enum value: TIMELINE_ITEM_TYPE_PULL_REQUEST_COMMIT = 4;
   */
  PULL_REQUEST_COMMIT = 4,

  /**
   * @generated from enum value: TIMELINE_ITEM_TYPE_CROSS_REFERENCE = 5;
   */
  CROSS_REFERENCE = 5,

  /**
   * @generated from enum value: TIMELINE_ITEM_TYPE_PULL_REQUEST_REVIEW_THREAD = 6;
   */
  PULL_REQUEST_REVIEW_THREAD = 6,

  /**
   * @generated from enum value: TIMELINE_ITEM_TYPE_PULL_REQUEST_REVISION_MARKER = 7;
   */
  PULL_REQUEST_REVISION_MARKER = 7,

  /**
   * @generated from enum value: TIMELINE_ITEM_TYPE_ISSUE_EDIT = 8;
   */
  ISSUE_EDIT = 8,

  /**
   * @generated from enum value: TIMELINE_ITEM_TYPE_COPILOT_WORK_STARTED_EVENT = 9;
   */
  COPILOT_WORK_STARTED_EVENT = 9,
}

/**
 * Describes the enum github.pull_requests.v1.TimelineItemType.
 */
export const TimelineItemTypeSchema: GenEnum<TimelineItemType> = /*@__PURE__*/
  enumDesc(file_pull_requests_v1_timeline, 0);

/**
 * @generated from enum github.pull_requests.v1.UserType
 */
export enum UserType {
  /**
   * @generated from enum value: USER_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: USER_TYPE_AGENT = 1;
   */
  AGENT = 1,

  /**
   * @generated from enum value: USER_TYPE_BOT = 2;
   */
  BOT = 2,

  /**
   * @generated from enum value: USER_TYPE_HUMAN = 3;
   */
  HUMAN = 3,
}

/**
 * Describes the enum github.pull_requests.v1.UserType.
 */
export const UserTypeSchema: GenEnum<UserType> = /*@__PURE__*/
  enumDesc(file_pull_requests_v1_timeline, 1);

import { registerSchemaHash } from "../../../schema-hash-registry";
registerSchemaHash(TimelineResponseSchema, "4e37b64e3de6")
registerSchemaHash(TimelineItemSchema, "b61f69d24def")
registerSchemaHash(TimelineUserSchema, "d603ebdf2950")
registerSchemaHash(LabelSchema, "43fb3d90d546")
registerSchemaHash(AdditionalInfoSchema, "428b3aceb856")
registerSchemaHash(IssueCommentInfoSchema, "b4aa85da5b07")
registerSchemaHash(IssueEventInfoSchema, "048aee8aec27")
registerSchemaHash(PullRequestReviewInfoSchema, "5d7eaaaca1b4")
registerSchemaHash(PullRequestCommitInfoSchema, "a97172c68c3d")
registerSchemaHash(CrossReferenceInfoSchema, "e578cbc8ce01")
registerSchemaHash(PullRequestRevisionMarkerInfoSchema, "c25da29cf05d")
registerSchemaHash(CopilotWorkStartedEventInfoSchema, "e13ead263136")
